export const toPascalCase = (str: string = ""): string => {
  const clean = String(str).toLowerCase().trim().replace(/\s+/g, " ");
  if (!clean) return "";

  return clean
    .split(" ")
    .map((word) =>
      word
        .split(/([-'])/g)
        .map((part) =>
          part === "-" || part === "'"
            ? part
            : part.charAt(0).toUpperCase() + part.slice(1)
        )
        .join("")
    )
    .join(" ");
};
